import VEHICLE_CAPABLE_ACTION from "../actionTypes/VehicleCapable";
import SUBSCRIPTION_ACTION from '../actionTypes/Subscriptions';
import { QRVALUE_ACTION_TYPES } from '../actionTypes';
import FORGEROCK_ACTION_TYPES from '../actionTypes/ForgeRock';

// reducer with initial state
const initialState = {
  loading:false,
  error:null,
  vehicle_capable: false,
};

const vehicleCapableReducer = (state = initialState, action) => {
  switch (action.type) {
    case VEHICLE_CAPABLE_ACTION.IS_VEHICLE_CAPABLE:
      return { ...state, loading: true};
    case VEHICLE_CAPABLE_ACTION.VEHICLE_CAPABLE_ERROR:
      return{...state,error:action.payload,loading:false};
    case VEHICLE_CAPABLE_ACTION.VEHICLE_CAPABLE_SUCCESS:
      return{...state,vehicle_capable: action.payload,loading:false,error:null}
    case SUBSCRIPTION_ACTION.SUBSCRIPTION_ERROR:
    case QRVALUE_ACTION_TYPES.POST.IN_PROGRESS:
    case FORGEROCK_ACTION_TYPES.AUTHORIZED_SUCCESS:
      return {...state,error:null}
    default:
      return state; // return initial state by default
  }
};

export default vehicleCapableReducer;
